import { Flex } from '@chakra-ui/react'
import { TravelHistoryTable } from './components/TravelHistoryTable'

function TravelHistoryPage() {
  return (
    <Flex direction='column' gap='20px' flex='1'>
      <TravelHistoryTable />
    </Flex>
  )
}

export default TravelHistoryPage
